import { createQueriesConfig, QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra';
import { getTldSelectorData } from './queries/getTldSelectorData';
export const CoreDomainSearchApiConfig = createQueriesConfig({
  getTldSelectorData: {
    queryFn: getTldSelectorData,
    queryConfigType: QueryConfigTypes.STATIC_DATA
  }
});
//# sourceMappingURL=config.js.map